import defaultApi from '@/utils/request';

export default {
  // ============================== S56W2001 ==================================
  // S56W2001 汽車車位申請作業
  // 取得汽車車位申請作業資料
  S56W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2001_Load',
      params,
    });
  },
  // 寫入汽車車位申請作業資料
  S56W2001_ViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S56/S56W2001_ViewAction',
      data,
    });
  },
  S56W2001_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2001_Query',
      params,
    });
  },
  S56W2001_LoadPrintData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2001_LoadPrintData',
      params,
    });
  },
  S56W2001_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2001_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },
  S56W2001_FileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S56/S56W2001_FileUpload',
      data,
    });
  },

  // ============================== S56W2002 ==================================
  // S56W2002 機車車位申請作業
  // 取得機車車位申請作業資料
  S56W2002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2002_Load',
      params,
    });
  },
  // 寫入機車車位申請作業資料
  S56W2002_ViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S56/S56W2002_ViewAction',
      data,
    });
  },
  S56W2002_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2002_Query',
      params,
    });
  },
  S56W2002_LoadPrintData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2002_LoadPrintData',
      params,
    });
  },
  S56W2002_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2002_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },
  S56W2002_FileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S56/S56W2002_FileUpload',
      data,
    });
  },

  // ============================== S56W2003 ==================================
  // S56W2003 大型重機車位申請作業
  // 取得大型重機車位申請作業資料
  S56W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2003_Load',
      params,
    });
  },
  // 寫入大型重機車位申請作業資料
  S56W2003_ViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S56/S56W2003_ViewAction',
      data,
    });
  },
  S56W2003_Query(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2003_Query',
      params,
    });
  },
  S56W2003_LoadPrintData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2003_LoadPrintData',
      params,
    });
  },
  S56W2003_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W2003_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },
  S56W2003_FileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S56/S56W2003_FileUpload',
      data,
    });
  },

  // ============================== S56W4003 =================================
  S56W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W4003_Load',
      params,
    });
  },
  S56W4003_LoadPrintData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W4003_LoadPrintData',
      params,
    });
  },
  S56W4003_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W4003_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },
  // ============================== S56W4004 =================================
  S56W4004_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W4004_Load',
      params,
    });
  },
  S56W4004_LoadPrintData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W4004_LoadPrintData',
      params,
    });
  },
  S56W4004_LoadPrintPDFData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S56/S56W4004_LoadPrintPDFData',
      responseType: 'blob',
      params,
    });
  },
  //= ============================================================================
};
